module.exports = __webpack_public_path__ + "media/images/librarian-96cd0948511c78c34d9bcd80a1ad2489.svg";